import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icons from '../../icons';

// TODO useCallback
const QuestionBlock = props => {
  const [isOpen, setIsOpen] = useState(props.isOpen || false);

  return (
    <div className={classnames('question-block', { 'is-open': isOpen, 'question-block-sm': props.isMobile || false })}>
      <div className="question is-flex justify-content-between" onClick={() => setIsOpen(!isOpen)}>
        <div>{props.question}</div>
        <div>{!isOpen ? <Icons.CaretDown /> : <Icons.CaretUp />}</div>
      </div>
      {isOpen && <p className="answer">{props.answer}</p>}
    </div>
  );
};

QuestionBlock.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default QuestionBlock;
